// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import xUseWidgetBadges from "@guestsupply/App/Hooks/xUseWidgetBadges";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { BadgeModel } from "@insite/client-framework/Types/ApiModels";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

interface Props {
    productContext: ProductContextModel;
    showTextBadge?: boolean;
    showImageBadge?: boolean;
    styles?: { badgeTextWrapper?: InjectableCss; badgeImageWrapper?: InjectableCss };
    isGridView?: boolean;
    showPreviouslyPurchased?: boolean;
    showBrandStandardName?: boolean;
    showIsAvendra?: boolean;
    // we need to display specific icon and text in pdp for avendra and non returnable
    isPdp?: boolean;
}

const xUseOverlayBadge = ({
    productContext,
    showTextBadge,
    showImageBadge,
    isGridView = true,
    showPreviouslyPurchased = true,
    showBrandStandardName = false,
    showIsAvendra = false,
    isPdp = false,
}: Props) => {
    let overlayBadgeWrapperStyles = null;
    const { ootbBadgesAndTags, customBadgesAndTags } = xUseWidgetBadges({
        productContext,
        showTextBadges: showTextBadge,
        showImageBadges: showImageBadge,
        showPreviouslyPurchased,
        showBrandStandardName,
        showIsAvendra,
        isPdp,
    });

    const badges: BadgeModel[] = [...(ootbBadgesAndTags || []), ...(customBadgesAndTags || [])];

    const overlayBadges = badges.filter(badge => badge.displayOnProductImages);

    overlayBadgeWrapperStyles = {
        css: css`
            display: flex;
            flex-wrap: wrap;
            gap: 8px;
            ${isGridView
                ? " position: absolute; bottom: 8px; left: 8px;"
                : " position: static; width: 100%; margin-top: 8px; display: block; > div[class^='LazyImageStyle'] { height: 22px; width: 22px; margin: 8px 8px 0 0; }"}
        `,
    };
    return {
        showOverlayBadge: overlayBadges.length > 0,
        overlayBadges,
        overlayBadgeWrapperStyles,
    };
};

// eslint-disable-next-line spire/export-styles
export default xUseOverlayBadge;
